import React from 'react';
import { FormattedMessage } from 'react-intl';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Spacer from 'components/structure/Spacer';
import Block from 'components/structure/Block/Block';
import ImageBlock from 'components/structure/ImageBlock';
import { paddingBuilder } from 'styles/themeUtils';

function SectionPillars() {
  return (
    <Section>
      <FormattedMessage id="CAREERS.PILLARS.IMAGE_ALT">
        {([alt]) => (
          <ImageBlock
            alt={alt}
            loading="lazy"
            backgroundImage="careers/careers.jpg"
          />
        )}
      </FormattedMessage>
      <Block
        padding={{
          default: paddingBuilder.bottom(0),
          desktop: paddingBuilder.left(0),
        }}
      >
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={3.5}
          intlKey="CAREERS.PILLARS.TITLE"
        />
        <ul>
          <li>
            <Link
              href="https://blog.nubank.com.br/desenvolvimento-mobile-do-nubank/"
              typographyProps={{
                variant: 'subtitle',
                color: 'black',
              }}
              intlKey="CAREERS.PILLARS.TECHNOLOGY_TITLE"
            />
            <Spacer multiplier={0.5} />
            <Typography
              variant="paragraph2"
              color="black"
              colorVariant="default"
              gutterBottom={2}
              intlKey="CAREERS.PILLARS.TECHNOLOGY_DESCRIPTION"
              intlValues={{
                a: (...msg) => (
                  <FormattedMessage id="CAREERS.PILLARS.TECHNOLOGY_DESCRIPTION.LINK">
                    {([link]) => (
                      <Link
                        href={link}
                        color="primary"
                        typographyProps={{
                          variant: 'paragraph2',
                        }}
                      >
                        {msg}
                      </Link>
                    )}
                  </FormattedMessage>
                ),
              }}
            />
          </li>
          <li>
            <Link
              href="https://blog.nubank.com.br/primeiros-dias-como-designer-no-nubank/"
              typographyProps={{
                variant: 'subtitle',
                color: 'black',
              }}
              intlKey="CAREERS.PILLARS.DESIGN_TITLE"
            />
            <Spacer multiplier={0.5} />
            <Typography
              variant="paragraph2"
              color="black"
              colorVariant="default"
              gutterBottom={2}
              intlKey="CAREERS.PILLARS.DESIGN_DESCRIPTION"
            />
          </li>
          <li>
            <Link
              href="https://blog.nubank.com.br/machine-learning-meetups-nubank/"
              typographyProps={{
                variant: 'subtitle',
                color: 'black',
              }}
              intlKey="CAREERS.PILLARS.DATA_SCIENCE_TITLE"
            />
            <Spacer multiplier={0.5} />
            <Typography
              variant="paragraph2"
              color="black"
              colorVariant="default"
              gutterBottom={2}
              intlKey="CAREERS.PILLARS.DATA_SCIENCE_DESCRIPTION"
            />
          </li>
          <li>
            <Link
              href="https://blog.nubank.com.br/nubank-atendimento-cliente-premios/"
              typographyProps={{
                variant: 'subtitle',
                color: 'black',
              }}
              intlKey="CAREERS.PILLARS.CUSTOMER_EXPERIENCE_TITLE"
            />
            <Spacer multiplier={0.5} />
            <Typography
              variant="paragraph2"
              color="black"
              colorVariant="default"
              intlKey="CAREERS.PILLARS.CUSTOMER_EXPERIENCE_DESCRIPTION"
              intlValues={{
                a: (...msg) => (
                  <FormattedMessage id="CAREERS.PILLARS.CUSTOMER_EXPERIENCE_DESCRIPTION.LINK">
                    {([link]) => (
                      <Link
                        href={link}
                        color="primary"
                        typographyProps={{
                          variant: 'paragraph2',
                        }}
                      >
                        {msg}
                      </Link>
                    )}
                  </FormattedMessage>
                ),
              }}
            />
          </li>
        </ul>
      </Block>
    </Section>
  );
}

export default React.memo(SectionPillars);
